import React from "react";
import { Modal } from "react-bootstrap";
import "./modal.scss";
import TimeTravelModel from "../../molecules/TimeTravelModel";
import BoostYourSavingsModal from "../../molecules/BoostYourSavingsModal";
import SavingsBreakdownModal from "../../molecules/SavingsBreakdownModal";
import SummaryOfChangesModal from "../../molecules/SummaryOfChangesModal";
import NotMaximisingModal from "../../molecules/NotMaximisingModal";
import ContributionsConfirmationModal from "../../molecules/ContributionsConfirmationModal";
import QRCodeModal from "../../molecules/QRCodeModal";
import QRCodeStatusModal from "../../molecules/QRCodeStatusModal";
import WhyNominateModal from "../../molecules/WhyNominateModal";
import AddBeneficiariesWarningModal from "../../molecules/AddBeneficiariesWarningModal";
import NominateByMembershipModal from "../../molecules/NominateByMembershipModal";
import ConfirmationModal from "../../molecules/ConfirmationModal";
import PotChargesModal from "../../molecules/PotChargesModal";
import SalarySacrificeModal from "../../molecules/SalarySacrificeModal";
import AVCsExplainedModal from "../../molecules/AVCsExplainedModal";
import ContributionBreakdownModal from "../../molecules/ContributionBreakdownModal";
import WhatToExpect from "../../molecules/WhatToExpectModal";
import UploadDocModal from "../../molecules/UploadDocModal";
import TaxFreeIllHealthModal from "../../molecules/TaxFreeIllHealthModal";
import MaximiseYourPensionModal from "../../molecules/MaximiseYourPensionModal";
import ChangeInvestmentModal from "../../molecules/ChangeInvestmentModal";
import ManageInvestmentModal from "../../molecules/ManageInvestmentModal";
import SummaryOfChanges from "../../molecules/SummaryOfChanges";
import RefreshTokenModal from "../../molecules/RefreshTokenModal";
import RetirementTimeline from "../../molecules/RetirementTimelineModal";
import ManageMembershipModal from "../../molecules/ManageMembershipModal";
import ManageTaxFreeAsIncome from "../../molecules/ManageTaxFreeAsIncome";
import AnnualAllowanceModal from "../../molecules/AnnualAllowanceModal";
import SmallPotModal from "../../molecules/SmallPotModal";
import TaxFreeSummaryOfChanges from "../../molecules/TaxFreeSummaryOfChanges";
import DrawSummaryOfChangesModal from "../../molecules/DrawdownSummaryOfChangesModal";
import DocumentPdfModal from "../../molecules/DocumentPdfModal";
import AnnualSalaryModal from "../../molecules/AnnaualSalaryEditModal";
import CalculatorAssumptionsModal from "../../molecules/CalculatorAssumptionsModal";
import WithdrawalRequestModal from "../../molecules/WithdrawalRequestModal";
import WithdrawalSummaryModal from "../../molecules/WithdrawalSummaryModal";
import ChooseFlexiAccessIncomeModal from "../../molecules/ChooseFlexiAcessIncomeModal";
import FlexiAccessModal from "../../molecules/FlexiAccessModal";
import FlexiAccessIncomeIllustrationModal from "../../molecules/FlexiAccessIncomeIllustrationModal";
import IncludeOtherRetirementModal from "../../molecules/IncludeOtherRetirementModal";
import OtherRetirementSavingsDBModal from "../../molecules/OtherRetirementSavingsModal";
import ReadModal from "../../molecules/ReadModal";
import HeadsupModal from "../../molecules/HeadsupModal";
import FutureCalcTaxfreeModal from "../../molecules/FutureCalcTaxfreeModal";
import ManagedMonthlyIncomeModal from "../../molecules/ManagedMonthlyIncomeModal";

import LimitationsYourChoicesModal from "../../molecules/LimitationsYourChoicesModal";
import YourGoalModal from "../../molecules/YourGoalModal";
import AboutFlexiAccessWithdrawalModal from "../../molecules/AboutFlexiAccessWithdrawalModal";
import YourBankTransferModal from "../../molecules/YourBankTransferModal";
import SelectIndividualPotModal from "../../molecules/SelectIndividualPotModal";
import TRAUpdatedModal from "../../molecules/TRAUpdateModal";
import TRAUpdateMultiplePotModal from "../../molecules/TRAUpdateMultiplePotModal";
import TRASelectageModal from "../../molecules/TRASelectageModal";
import SelectIndividualDrawdownModal from "../../molecules/SelectIndividualDrawdownModal";
import MessageModal from "../../molecules/MessageModal";
import OtherPensionsLumpSumAllowancesModel from "../../molecules/OtherPensionsLumpSumAllowances";
import ChoosingFlexiAccessRetirementModel from "../../molecules/ChoosingFlexiAccessRetirementPopup";
import FlexiAccessSummaryOfChangesModal from "../../molecules/FlexiAccessSummaryOfChangesModal";
import FlexiAccessConfirmModal from "../../molecules/FlexiAccessConfirmModal";
import SignoutModal from "../../molecules/SingoutModal";
import CombiningTptPotsModal from "../../molecules/CombiningTptPotsModal";
import MoreThan95Modal from "../../molecules/MoreThan95Modal";
import TRAWhenFundSwitchRequiredModal from "../../molecules/TRAWhenFundSwitchRequired";
import MoreThan95PercentIncomeModal from "../../molecules/MoreThan95PercentIncomeModal";

export const ModalOverlay = (props) => {
  const getValue = (object) => {
    props.handleClick(object);
  };
  let popnameClassName = "modal-container";
  let size = "xl";
  if (props.popup === "changeyourregularcontribution") {
    popnameClassName = "change-your-contri-modal";
    size = "l";
  } else if (props.popup === "SummaryOfChanges") {
    popnameClassName = "summar-of-changes-modal";
    size = "lg";
  } else if (
    props.popup === "ContributionConfirm" ||
    props.popup === "FeedbackConfirm" ||
    props.popup === "PensionLabConfirmation"
  ) {
    popnameClassName = "contribution-confirm-modal";
    size = props.popup === "PensionLabConfirmation" ? "lg" : "m";
  } else if (props.popup === "QRCodeModal") {
    popnameClassName = "qr-code-modal";
    size = "lg";
  } else if (props.popup === "QRCodeStatusModal") {
    popnameClassName = "qr-code-status-modal";
    size = "m";
  } else if (props.popup === "WhyNominateModal") {
    popnameClassName = "why-nominate-modal-container";
    size = "l";
  } else if (
    props.popup === "DeleteBeneficiary" ||
    props.popup === "AddBeneficiary" ||
    props.popup === "CancelBeneficiary"
  ) {
    popnameClassName = "beneficiary-modal";
    size = "l";
  } else if (props.popup === "SaveBeneficiaries") {
    popnameClassName = "beneficiary-modal";
    size = "";
  } else if (props.popup === "AddBeneficiaryWarningModal") {
    popnameClassName = "add-beneficiary-warning-modal";
    size = "l";
  } else if (props.popup === "NominateMembershipModal") {
    popnameClassName = "nominate-membership-modal";
    size = "xl nominate-modal-size";
  } else if (props.popup === "potChargesModal") {
    popnameClassName = "pot-charges-modal";
    size = "lg";
  } else if (props.popup === "salarySacrificeModal") {
    popnameClassName = "salary-sacrifice-modal";
    size = "l";
  } else if (props.popup === "MaximiseYourPensionModal") {
    popnameClassName = "maximise-your-pension-modal";
    size = "l";
  } else if (props.popup === "AVCsExplainedModal") {
    popnameClassName = "avcs-explained-modal";
    size = "l";
  } else if (props.popup === "ContributionBreakdown") {
    popnameClassName = "contribution-breakdown-modal";
    size = "lg";
  } else if (props.popup === "whatToExpect") {
    popnameClassName = "what-to-expect-modal-container";
    size = "xl";
  } else if (props.popup === "UploadDocModal") {
    popnameClassName = "upload-document-modal";
    size = "lg";
  } else if (props.popup === "changeInvestment") {
    popnameClassName = "change-investment";
    size = "xl";
  } else if (props.popup === "manageInvestment") {
    popnameClassName = "manage-investment";
    size = "xl";
  } else if (
    props.popup === "illHealthModal" ||
    props.popup === "taxFreeModal" ||
    props.popup === "taxFreeConfirmModal" ||
    props.popup === "expectedLumpSumMoreThanAllowance" ||
    props.popup === "combiningTptPots"
  ) {
    popnameClassName = "tax-free-ill-health-modal-container";
    size = "l";
  } else if (props.popup === "annualAllowance") {
    popnameClassName = "annual-allowance";
    size = "l";
  } else if (props.popup === "ManageMembershipModal") {
    popnameClassName = "mange-membership-modal";
    size = "xl";
  } else if (props.popup === "summaryOfChanges") {
    popnameClassName = "summary-of-changes-modal";
    size = "xl";
  } else if (props.popup === "changesConfirmed") {
    popnameClassName = "summary-changes-confirm";
    size = "m";
  } else if (props.popup === "refreshToken") {
    popnameClassName = "refresh-token-modal";
    size = "m";
  } else if (props.popup === "manageTaxFree") {
    popnameClassName = "manage-tax-free-modal";
    size = "lg";
  } else if (props.popup === "smallPot") {
    popnameClassName = "smallpot-modal";
    size = "l";
  } else if (props.popup === "taxFreeSummaryOfChanges") {
    popnameClassName = "tax-free-summary-changes-modal";
    size = "xl";
  } else if (props.popup === "tfchangesConfirmed") {
    popnameClassName = "tf-summary-changes-confirm";
    size = "m";
  } else if (props.popup === "drawdownSummaryOfChanges") {
    popnameClassName = "drawdown-summary-changes-modal";
    size = "xl";
  } else if (props.popup === "ddchangesConfirmed") {
    popnameClassName = "dd-summary-changes-confirm";
    size = "m";
  } else if (
    props.popup === "chooseFlexiAccessIncome" ||
    props.popup === "choosingFlexiAccessRetirement"
  ) {
    popnameClassName = "flexi-access-income-modal";
    size = "xl";
  } else if (props.popup === "flexiAccessModal") {
    popnameClassName = "flexi-access-modal";
    size = "m";
  } else if (props.popup === "documentPdfView") {
    popnameClassName = "documentpdf-modal";
    size = "m";
  } else if (
    props.popup === "annualSalaryEdit" ||
    props.popup === "includeOtherRetirement" ||
    props.popup === "otherRetirementSavingsDB"
  ) {
    popnameClassName = "annual-salary-edit-modal";
    size = "xl annual-salary-edit-size";
  } else if (props.popup === "calculatorAssumptions") {
    popnameClassName = "calculator-assumptions-modal";
    size = "l";
  } else if (props.popup === "WithdrawalSummary") {
    popnameClassName = "withdrawal-summary-modal";
    size = "xl";
  } else if (props.popup === "WithdrawalRequestReceived") {
    popnameClassName = "withdrawal-req-modal";
    size = "m";
  } else if (props.popup === "flexiAccessIncomeIllustration") {
    popnameClassName = "flexi-acces-income-illustration-modal";
    size = "xl";
  } else if (props.popup === "ReadModal") {
    popnameClassName = "read-modal";
    size = "xl";
  } else if (props.popup === "BoostYourSavings") {
    popnameClassName = "boost-your-savings-modal";
    size = "xl boost-your-savings-size";
  } else if (props.popup === "retirementTimeline") {
    popnameClassName = "retirement-timeline-modal";
    size = "l";
  } else if (
    props.popup === "limitationsYourChoices" ||
    props.popup === "RetirementApplicationSuccessModal" ||
    props.popup === "LeavingTPTSuccessModel"
  ) {
    popnameClassName = "limitations-your-choices";
    size = "l";
  } else if (props.popup === "yourgoals") {
    popnameClassName = "your-goals-modal";
    size = "xl your-goals-size";
  } else if (props.popup === "heads-up") {
    popnameClassName = "headsup";
    size = "m";
  } else if (props.popup === "fc-taxfree-modal") {
    popnameClassName = "fc-taxfree-modal";
    size = "m";
  } else if (props.popup === "managedmonthlyincome") {
    popnameClassName = "managedmonthlyincome-modal";
    size = "xl";
  } else if (props.popup === "AboutFlexiAccessWithdrawal") {
    popnameClassName = "AboutFlexiAccessWithdrawal-modal";
    size = "m";
  } else if (props.popup === "yourbanktransfer") {
    popnameClassName = "yourbanktransfer-modal";
    size = "m";
  } else if (props.popup === "individualpot") {
    popnameClassName = "individualpot-modal";
    size = "xl";
  } else if (
    props.popup === "TRAUpdatedModal" ||
    props.popup === "TRAWhenFundSwitchRequiredModal"
  ) {
    popnameClassName = "manage-investment";
    size = "l";
  } else if (props.popup === "TRAMultiplePotSelection") {
    popnameClassName = "mange-membership-modal";
    size = "lg";
  } else if (props.popup === "SelectTRA") {
    popnameClassName = "maximise-your-pension-modal";
    size = "l";
  } else if (props.popup === "selectIndividualDrawdown") {
    popnameClassName = "mange-membership-modal";
    size = "xl";
  } else if (props.popup === "messageModal") {
    popnameClassName = "message-modal";
    size = "xl";
  } else if (props.popup === "flexiAccessSummaryOfChanges") {
    popnameClassName = "summary-of-changes-modal";
    size = "xl";
  } else if (props.popup === "flexiChangesConfirmed") {
    popnameClassName = "summary-changes-confirm";
    size = "m";
  } else if (props.popup === "flexiAccessIncomeConfirm") {
    popnameClassName = "flexi-access-income-confirm";
    size = "m";
  } else if (props.popup === "signoutModal") {
    popnameClassName = "sign-out-confirm";
    size = "m";
  } else if (props.popup === "morethan95") {
    popnameClassName = "morethan95-modal";
    size = "m";
  } else if (props.popup === "moreThan95PercentIncome") {
    popnameClassName = "more-than-95-percent-income-modal";
    size = "m";
  }

  const ariaLabel =
    props.modalTitle || props.headTitle || props.statusTitle || "Dialog Modal";

  return (
    <Modal
      size={size}
      aria-labelledby="contained-modal-title-vcenter"
      aria-label={ariaLabel}
      centered
      show={props.show}
      onHide={props.onHide}
      backdrop={
        props.disableBackdropClose !== undefined &&
        props.disableBackdropClose === true
          ? "static"
          : true
      }
      keyboard={
        props.disableEscClose !== undefined && props.disableEscClose === true
          ? false
          : true
      }
      contentClassName={
        props.popup === "SaveBeneficiaries"
          ? "modal-size modal-success"
          : props.popup === "changeInvestment"
            ? "changeInvestment-size"
            : props.popup === "manageInvestment"
              ? "manageInvestment-size"
              : props.popup === "ManageMembershipModal"
                ? "manageInvestmentMembership-size"
                : props.popup === "taxFreeSummaryOfChanges"
                  ? "taxFreeSummaryOfChanges-size"
                  : props.popup === "drawdownSummaryOfChanges"
                    ? "drawdownSummaryOfChanges-size"
                    : props.popup === "chooseFlexiAccessIncome" ||
                        props.popup === "choosingFlexiAccessRetirement"
                      ? "chooseFlexiAccessIncome-size"
                      : props.popup === "flexiAccessModal"
                        ? "flexiAccessModal-size"
                        : props.popup === "flexiAccessIncomeIllustration"
                          ? "flexiAccessIncomeIllustration-size"
                          : props.popup === "managedmonthlyincome"
                            ? "managedmonthlyincome-modal-size"
                            : props.popup === "individualpot"
                              ? "manageInvestmentMembership-size"
                              : props.popup === "WithdrawalSummary"
                                ? "withdrawalSummary-modal-size"
                                : props.popup === "selectIndividualDrawdown"
                                  ? "manageInvestmentMembership-size"
                                  : props.popup === "morethan95"
                                    ? "morethan95-modal-size"
                                    : props.popup === "moreThan95PercentIncome"
                                      ? "moreThan95PercentIncome-modal-size"
                                      : "modal-size"
      }
      tabIndex="0"
    >
      {/* {props.popup === "DeleteBeneficiary" ? <Modal.Header closeButton /> : ""} */}
      <Modal.Body className={popnameClassName}>
        {props.popup === "BoostYourSavings" ? (
          <BoostYourSavingsModal
            investorId={props.investorId}
            modalTitle={props.modalTitle}
            description={props.description}
            handleCloseButton={props.onHide}
          />
        ) : props.popup === "timetravel" ? (
          <TimeTravelModel
            handleCloseButton={props.onHide}
            personAge={props.personAge}
            retirementYear={props.retirementYear}
            estimatedVal={props.estimatedVal}
            newRetirementYear={props.newRetirementYear}
            initialEstimatedVal={props.initialEstimatedVal}
            investorObject={props.investorObject}
            timeTravel={props.timeTravel}
            newPersonAge={props.newPersonAge}
            getValue={getValue}
            totalFund={props.totalFund}
          />
        ) : props.popup === "PotsBreakDown" ? (
          <SavingsBreakdownModal
            handleCloseButton={props.onHide}
            potData={props.potData}
            asOfDate={props.asOfDate}
            aboutTptModalText={props.aboutTptModalText}
          />
        ) : props.popup === "yourgoals" ? (
          <YourGoalModal
            handleCloseButton={props.onHide}
            modalTitle={props.modalTitle}
            investorId={props.investorId}
            isTaskUpdated={props.isTaskUpdated}
            setModalShow={props.setModalShow}
          />
        ) : props.popup === "savingssummary" ? (
          <YourGoalModal
            handleCloseButton={props.onHide}
            modalTitle="Savings summary"
            savingsSummary="This is a summary your Savings Account. Savings is a vital component of your life. Most importantly you can also rely on savings for safeguarding your family’s needs and providing financial security in unfavorable times. But it is important to find an instrument that allows your savings to grow."
          />
        ) : props.popup === "SummaryOfChanges" ? (
          <SummaryOfChangesModal
            handleCloseButton={props.onHide}
            setSummaryModalShow={props.setSummaryModalShow}
            setShowConfirm={props.setShowConfirm}
            investorId={props.investorId}
            modalTitle={props.modaltitle}
            govtSupportPercentage={props.govtSupportPercentage}
            isSelectedItem={props.isSelectedItem}
            contributionValue={props.contributionValue}
            contributionErValue={props.contributionErValue}
            youContributePrice={props.youContributePrice}
            yourEmpContributPrice={props.yourEmpContributPrice}
            totalContributionPrice={props.totalContributionPrice}
            youPayValue={props.youPayValue}
            avc={props.avc}
            aVContributionValue={props.aVContributionValue}
            avcPercentageValue={props.avcPercentageValue}
            totalAVContributionPrice={props.totalAVContributionPrice}
            youPayAVCValue={props.youPayAVCValue}
            salarySacrificeContribution={props.salarySacrificeContribution}
            gradeException={props.gradeException}
          />
        ) : props.popup === "changeyourregularcontribution" ? (
          <>
            <NotMaximisingModal
              handleCloseButton={props.onHide}
              modalTitle="Change your regular contributions"
              potIndex={props.potIndex}
              data={props.data}
              isSetupAvc={props.isSetupAvc}
              gradeException={props.gradeException}
            />
          </>
        ) : props.popup === "ContributionConfirm" ||
          props.popup === "FeedbackConfirm" ||
          props.popup === "PensionLabConfirmation" ? (
          <>
            <ContributionsConfirmationModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              handlePensionLabLinkClick={props.handlePensionLabLinkClick}
              parentFile={props.parentFile}
              consent={props.consent}
              setConsent={props.setConsent}
            />
          </>
        ) : props.popup === "QRCodeModal" ? (
          <>
            <QRCodeModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              QRcodeURL={props?.QRcodeURL}
              QRcodeBase64={props?.QRcodeBase64}
              changedField={props?.changedField}
              requiredDocumentList={props?.requiredDocumentList}
              modalShowField={props.modalShowField}
            />
          </>
        ) : props.popup === "QRCodeStatusModal" ? (
          <>
            <QRCodeStatusModal
              handleCloseButton={props.onHide}
              status={props.status}
              statusTitle={props?.statusTitle}
              statusText={props?.statusText}
            />
          </>
        ) : props.popup === "DeleteBeneficiary" ? (
          <>
            <ConfirmationModal
              popup={props.popup}
              handleCloseButton={props.onHide}
              heading="Are you sure?"
              details="We'll remove the details of this beneficiary, but you'll
              need to ensure any remaining beneficiaries and any you add sum up
              to 100% of your benefits."
              cancelButton="No, go back"
              confirmButton="Yes, remove"
              cancelHandler={props.cancel}
              confirmHandler={props.confirm}
            />
          </>
        ) : props.popup === "AddBeneficiary" ? (
          <>
            <ConfirmationModal
              popup={props.popup}
              handleCloseButton={props.onHide}
              heading="Can't add another beneficiary"
              details="You have completed 100% of your nominations. Please update a nomination before adding another beneficiary."
              cancelButton="Go back"
              cancelHandler={props.cancel}
            />
          </>
        ) : props.popup === "CancelBeneficiary" ? (
          <>
            <ConfirmationModal
              popup={props.popup}
              handleCloseButton={props.onHide}
              heading="Are you sure you want to cancel?"
              details="Any beneficiaries data you've entered will be lost but you can come back to complete the process later."
              cancelButton="No, go back"
              confirmButton="Yes, cancel"
              cancelHandler={props.cancel}
              confirmHandler={props.confirm}
            />
          </>
        ) : props.popup === "SaveBeneficiaries" ? (
          <>
            <ConfirmationModal
              popup={props.popup}
              handleCloseButton={props.onHide}
              heading="Success!"
              details="Your nominations have been saved"
              confirmButton="Return to beneficiaries"
              confirmHandler={props.confirm}
            />
          </>
        ) : props.popup === "WhyNominateModal" ? (
          <WhyNominateModal
            handleCloseButton={props.onHide}
            isActiveMember={props.isActiveMember}
          />
        ) : props.popup === "AddBeneficiaryWarningModal" ? (
          <AddBeneficiariesWarningModal
            handleCloseButton={props.onHide}
            onContinueHandler={props.onContinueHandler}
            onSelectHandler={props.onSelectHandler}
          />
        ) : props.popup === "NominateMembershipModal" ? (
          <NominateByMembershipModal
            handleCloseButton={props.onHide}
            onContinueHandler={props.onContinueHandler}
            onSelectHandler={props.onSelectHandler}
            handleBack={props.handleBack}
            handleContinue={props.handleContinue}
            getSelectedPot={props.getSelectedPot}
            isEditMode={props.isEditMode}
            totalPotsData={props.totalPotsData}
          />
        ) : props.popup === "potChargesModal" ? (
          <PotChargesModal
            handleCloseButton={props.onHide}
            modalTitle={props.modalTitle}
            potName={props.potName}
            potId={props.potId}
            adminCharge={props.adminCharge}
            data={props.data}
            retirementYear={props.retirementYear}
            investmentFunds={props.investmentFunds}
            birthYear={props.birthYear}
            GP3={props.GP3}
          />
        ) : props.popup === "salarySacrificeModal" ? (
          <SalarySacrificeModal
            handleCloseButton={props.onHide}
            headTitle={props.headTitle}
            description={props.description}
            subDescription={props.subDescription}
            subDescription1={props.subDescription1}
            btnCancelName={props.btnCancelName}
            btnSendName={props.btnSendName}
            handleSendLink={props.handleSendLink}
            handleOpenUrl={props.handleOpenUrl}
            btnLinkName={props.btnLinkName}
          />
        ) : props.popup === "MaximiseYourPensionModal" ? (
          <MaximiseYourPensionModal
            handleCloseButton={props.onHide}
            headTitle={props.headTitle}
            description={props.description}
            subDescription={props.subDescription}
          />
        ) : props.popup === "AVCsExplainedModal" ? (
          <AVCsExplainedModal
            handleCloseButton={props.onHide}
            headTitle={props.headTitle}
            description={props.description}
            subDescription={props.subDescription}
            subDescription1={props.subDescription1}
          />
        ) : props.popup === "ContributionBreakdown" ? (
          <>
            <ContributionBreakdownModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              selectedMemberShip={props.selectedMemberShip}
            />
          </>
        ) : props.popup === "whatToExpect" ? (
          <WhatToExpect handleCloseButton={props.onHide} />
        ) : props.popup === "UploadDocModal" ? (
          <>
            <UploadDocModal
              handleCloseButton={props.onHide}
              status={props.status}
              uploadChangeDocument={props?.uploadChangeDocument}
              investorId={props?.investorId}
            />
          </>
        ) : props.popup === "illHealthModal" ||
          props.popup === "taxFreeModal" ||
          props.popup === "taxFreeConfirmModal" ? (
          <TaxFreeIllHealthModal
            handleCloseButton={props.onHide}
            headTitle={props.headTitle}
            description={props.description}
            subDescription={props.subDescription}
            question={props.question}
            btnCancelName={props.btnCancelName}
            btnSendName={props.btnSendName}
            handleSendLink={props.handleSendLink}
            btnCloseName={props.btnCloseName}
          />
        ) : props.popup === "annualAllowance" ? (
          <>
            <AnnualAllowanceModal
              handleCloseButton={props.onHide}
              handleClick={props.handleClick}
              headTitle={props.headTitle}
              description={props.description}
              subDescription={props.subDescription}
              btnSendName={props.btnSendName}
              btnCloseName={props.btnCloseName}
              classNames={props?.classNames}
            />
          </>
        ) : props.popup === "expectedLumpSumMoreThanAllowance" ? (
          <>
            <OtherPensionsLumpSumAllowancesModel
              handleCloseButton={props.onHide}
              headTitle={props.headTitle}
              description={props.description}
              subDescription={props.subDescription}
              question={props.question}
              btnCancelName={props.btnCancelName}
              btnSendName={props.btnSendName}
              handleSendLink={props.handleSendLink}
              btnCloseName={props.btnCloseName}
            />
          </>
        ) : props.popup === "ManageMembershipModal" ? (
          <>
            <ManageMembershipModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              individualMembershipData={props.individualMembershipData}
              handleManageBackButton={props.handleManageBackButton}
              handleContinueButton={props.handleContinueButton}
              memberships={props.memberships}
              memberType={props.memberType}
            />
          </>
        ) : props.popup === "changeInvestment" ? (
          <>
            <ChangeInvestmentModal
              memberships={props.memberships}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
              handleManageInvestments={props.handleManageInvestments}
              investmentStrategyKey={props.investmentStrategyKey}
              handleBack={props.handleBack}
              memberType={props.memberType}
            />
          </>
        ) : props.popup === "manageInvestment" ? (
          <>
            <ManageInvestmentModal
              handleCloseButton={props.onHide}
              handleBackButton={props.handleBackButton}
              investmentStrategy={props.investmentStrategy}
              handleManageInvestmentContinue={
                props.handleManageInvestmentContinue
              }
              memberships={props.memberships}
              data={props.data}
            />
          </>
        ) : props.popup === "summaryOfChanges" ? (
          <>
            <SummaryOfChanges
              data={props.finalFund}
              modaltitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
              investmentStrategy={props.investmentStrategy}
              investmentStrategyKey={props.investmentStrategyKey}
              memberships={props.memberships}
              fundSwitchFetching={props.fundSwitchFetching}
              fundSwitchFutureFetching={props.fundSwitchFutureFetching}
              fundSwitchError={props.fundSwitchError}
              fundSwitchFutureError={props.fundSwitchFutureError}
              errorShown={props.errorShown}
            />
          </>
        ) : props.popup === "changesConfirmed" ? (
          <>
            <SummaryOfChanges
              modaltitle={props.modaltitle}
              investmentStrategyKey={props.investmentStrategyKey}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
              disableBackdropClose={props.disableBackdropClose}
            />
          </>
        ) : props.popup === "refreshToken" ? (
          <>
            <RefreshTokenModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
            />
          </>
        ) : props.popup === "manageTaxFree" ? (
          <>
            <ManageTaxFreeAsIncome
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              taxFreeContinue={props.taxFreeContinue}
              handleContinueStop={props.handleContinueStop}
              investorId={props.investorId}
              investorAccountId={props.investorAccountId}
              totalFund={props.totalFund}
              cardsData={props.cardsData}
            />
          </>
        ) : props.popup === "taxFreeSummaryOfChanges" ? (
          <>
            <TaxFreeSummaryOfChanges
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              taxFreeData={props.taxFreeData}
              newTaxFreeData={props.newTaxFreeData}
              modaltitle={props.modaltitle}
              handleContinue={props.handleContinue}
              handleContinueStop={props.handleContinueStop}
              investorId={props.investorId}
              investorAccountId={props.investorAccountId}
              setTaxFreeError={props.setTaxFreeError}
              taxFreeError={props.taxFreeError}
            />
          </>
        ) : props.popup === "tfchangesConfirmed" ? (
          <>
            <TaxFreeSummaryOfChanges
              modaltitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
              isConfirm={props.isConfirm}
            />
          </>
        ) : props.popup === "drawdownSummaryOfChanges" ? (
          <>
            <DrawSummaryOfChangesModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              finalDrawdownStrategies={props.finalDrawdownStrategies}
              handleContinue={props.handleContinue}
              fundSwitchFetching={props.fundSwitchFetching}
              flexiAccessFetching={props.flexiAccessFetching}
              fundSwitchError={props.fundSwitchError}
              errorShown={props.errorShown}
            />
          </>
        ) : props.popup === "ddchangesConfirmed" ? (
          <>
            <DrawSummaryOfChangesModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
            />
          </>
        ) : props.popup === "chooseFlexiAccessIncome" ? (
          <>
            <ChooseFlexiAccessIncomeModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              isCancel={props.isCancel}
              flexiAcessCurrentIncome={props.flexiAccessCurrentIncome}
              flexiAccessDuration={props.flexiAccessDuration}
              handleFlexiAccessContinue={props.handleFlexiAccessContinue}
              handleProceedWithoutIncome={props.handleProceedWithoutIncome}
              currentValue={props.currentValue}
              directFromManage={props.directFromManage}
            />
          </>
        ) : props.popup === "choosingFlexiAccessRetirement" ? (
          <>
            <ChoosingFlexiAccessRetirementModel
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              isCancel={props.isCancel}
              flexiAcessCurrentIncome={props.flexiAccessCurrentIncome}
              flexiAccessDuration={props.flexiAccessDuration}
              handleFlexiAccessContinue={props.handleFlexiAccessContinue}
              flexiAccessTotalValue={
                props.flexiAccessTotalValue //eslint-disable-line
              }
            />
          </>
        ) : props.popup === "flexiAccessModal" ? (
          <>
            <FlexiAccessModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleFlexiAccessContinue={props.handleFlexiAccessContinue}
            />
          </>
        ) : props.popup === "flexiAccessIncomeIllustration" ? (
          <>
            <FlexiAccessIncomeIllustrationModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              flexiAcessCurrentIncome={props.flexiAccessCurrentIncome}
              initialFlexiObject={props.initialFlexiObject}
              updatedFlexiObject={props.updatedFlexiObject}
              flexiAccessDuration={props.flexiAccessDuration}
              handleIllustrationContinue={props.handleIllustrationContinue}
              flexiAccessFetching={props.flexiAccessFetching}
              flexiAccessError={props.flexiAccessError}
              errorShown={props.errorShown}
              directFromManage={props.directFromManage}
            />
          </>
        ) : props.popup === "limitationsYourChoices" ||
          props.popup === "RetirementApplicationSuccessModal" ||
          props.popup === "LeavingTPTSuccessModel" ? (
          <>
            <LimitationsYourChoicesModal
              handleCloseButton={props.onHide}
              iconTik={props.iconTik}
              txtStyle={props.txtStyle}
              headTitle={props.headTitle}
              description={props.description}
              descriptionOne={props.descriptionOne}
              descriptionTwo={props.descriptionTwo}
              subDescription={props.subDescription}
              btnCancelName={props.btnCancelName}
              btnUserOtherName={props.btnUserOtherName}
              btnContinuedName={props.btnContinuedName}
              handleContinue={props.handleContinue}
              handleTimeline={props.handleTimeline}
              handleClick={props.handleClick}
            />
          </>
        ) : props.popup === "smallPot" ? (
          <>
            <SmallPotModal
              handleCloseButton={props.onHide}
              headTitle={props.headTitle}
              description={props.description}
              subDescription={props.subDescription}
              btnSendName={props.btnSendName}
              btnCloseName={props.btnCloseName}
            />
          </>
        ) : props.popup === "annualSalaryEdit" ? (
          <>
            <AnnualSalaryModal
              handleCloseButton={props.onHide}
              modalTitle={props.modalTitle}
              description={props.description}
              subHeading={props.subHeading}
              subDescription={props.subDescription}
              getForecastValue={props.getForecastValue}
              annualSalary={props.annualSalary}
              setAnnualSalary={props.setAnnualSalary}
              actualAnnualSalary={props.actualAnnualSalary}
              setAnnualSalaryEditModal={props.setAnnualSalaryEditModal}
              btnBackHandler={props.btnBackHandler}
            />
          </>
        ) : props.popup === "calculatorAssumptions" ? (
          <>
            <CalculatorAssumptionsModal
              handleCloseButton={props.onHide}
              modalTitle={props.modalTitle}
              btnGotItHandler={props.btnGotItHandler}
              assumptionsFetch={props.assumptionsFetch}
              assumptionsData={props.assumptionsData}
              assumptionsError={props.assumptionsError}
            />
          </>
        ) : props.popup === "WithdrawalSummary" ? (
          <>
            <WithdrawalSummaryModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
              strategies={props.strategies}
              initialStrategies={props.initialStrategies}
              lumpSumsFetching={props.lumpSumsFetching}
              lumpSumsError={props.lumpSumsError}
              errorShown={props.errorShown}
            />
          </>
        ) : props.popup === "WithdrawalRequestReceived" ? (
          <>
            <WithdrawalRequestModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
            />
          </>
        ) : props.popup === "includeOtherRetirement" ? (
          <>
            <IncludeOtherRetirementModal
              handleCloseButton={props.onHide}
              modalTitle={props.modalTitle}
              description={props.description}
              tptTotalPot={props.tptTotalPot}
              linkedPensionValue={props.linkedPensionValue}
              statePensionValue={props.statePensionValue}
              otherIncomeDBModal={props.otherIncomeDBModal}
              setOtherIncomeDBModal={props.setOtherIncomeDBModal}
              otherRetirementModal={props.otherRetirementModal}
              setOtherRetirementModal={props.setOtherRetirementModal}
              expectedSavingsIncome={props.expectedSavingsIncome}
              setExpectedSavingsIncome={props.setExpectedSavingsIncome}
              dBEstIncome={props.dBEstIncome}
              setDBEstIncome={props.setDBEstIncome}
              otherIncomeDBAge={props.otherIncomeDBAge}
              setOtherIncomeDBAge={props.setOtherIncomeDBAge}
              btnDoneHandler={props.btnDoneHandler}
              membershipType={props.membershipType}
            />
          </>
        ) : props.popup === "otherRetirementSavingsDB" ? (
          <>
            <OtherRetirementSavingsDBModal
              handleCloseButton={props.onHide}
              modalTitle={props.modalTitle}
              description={props.description}
              subHeading={props.subHeading}
              subDescription={props.subDescription}
              expectedSavingsIncome={props.expectedSavingsIncome}
              setExpectedSavingsIncome={props.setExpectedSavingsIncome}
              dBEstIncome={props.dBEstIncome}
              setDBEstIncome={props.setDBEstIncome}
              otherIncomeDBAge={props.otherIncomeDBAge}
              setOtherIncomeDBAge={props.setOtherIncomeDBAge}
              otherRetirementModal={props.otherRetirementModal}
              setOtherRetirementModal={props.setOtherRetirementModal}
              setOtherIncomeDBModal={props.setOtherIncomeDBModal}
              btnBackHandler={props.btnBackHandler}
              btnDoneHandler={props.btnDoneHandler}
              section={props.section}
              membershipType={props.membershipType}
            />
          </>
        ) : props.popup === "ReadModal" ? (
          <>
            <ReadModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              data={props.data}
              onHide={props.onHide}
              setReadModalShow={props.setReadModalShow}
              helpGuides={props.helpGuides}
              learnData={props.learnData}
            />
          </>
        ) : props.popup === "documentPdfView" ? (
          <>
            <DocumentPdfModal
              docData={props.docData}
              modaltitle={props.modaltitle}
              selectedDocIndex={props.selectedDocIndex}
              selectedDocIsRead={props.selectedDocIsRead}
              makeApiToInsertDocStatus={props.makeApiToInsertDocStatus}
              investorId={props.investorId}
              onHide={props.onHide}
            />
          </>
        ) : props.popup === "retirementTimeline" ? (
          <>
            <RetirementTimeline
              handleCloseButton={props.onHide}
              modalTitle={props.modalTitle}
              description={props.description}
              subHeading={props.subHeading}
              subDescription={props.subDescription}
              annualSalary={props.annualSalary}
              setAnnualSalaryEditModal={props.setAnnualSalaryEditModal}
              btnBackHandler={props.btnBackHandler}
              btnNext={props.btnNext}
              btnPre={props.btnPre}
              btnGotit={props.btnGotit}
              handleClick={props.handleClick}
            />
          </>
        ) : props.popup === "heads-up" ? (
          <>
            <HeadsupModal
              onHide={props.onHide}
              handleCloseButton={props.onHide}
              handleClick={props.handleClick}
            />
          </>
        ) : props.popup === "fc-taxfree-modal" ? (
          <>
            <FutureCalcTaxfreeModal
              onHide={props.onHide}
              handleCloseButton={props.onHide}
              handleClick={props.handleClick}
            />
          </>
        ) : props.popup === "managedmonthlyincome" ? (
          <>
            <ManagedMonthlyIncomeModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              flexiLinechartData={props?.flexiLinechartData}
              flexiIncomechartData={props?.flexiIncomechartData}
              IncomechartData={props?.IncomechartData}
              AnnuitychartData={props?.AnnuitychartData}
              activeChart={props?.activeChart}
              spSwitch={props?.spSwitch}
              annuityData={props?.annuityData}
              incomeData={props?.incomeData}
              isAnnaulSwitchOn={props?.isAnnaulSwitchOn}
              flexiData={props?.flexiData}
            />
          </>
        ) : props.popup === "AboutFlexiAccessWithdrawal" ? (
          <>
            <AboutFlexiAccessWithdrawalModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
              strategies={props.strategies}
              handleIllustration={props.handleIllustration}
            />
          </>
        ) : props.popup === "yourbanktransfer" ? (
          <>
            <YourBankTransferModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
            />
          </>
        ) : props.popup === "individualpot" ? (
          <>
            <SelectIndividualPotModal
              modalTitle={props.modaltitle}
              multiDrawdownWithdraw={props.multiDrawdownWithdraw}
              handleCloseButton={props.onHide}
              handleContinueButton={props.handleContinueButton}
            />
          </>
        ) : props.popup === "TRAUpdatedModal" ? (
          <>
            <TRAUpdatedModal
              handleCloseButton={props.onHide}
              handleBackButton={props.handleBackButton}
              isForSinglePot={props.isForSinglePot}
              onCloseClick={props.onCloseClick}
            />
          </>
        ) : props.popup === "TRAMultiplePotSelection" ? (
          <>
            <TRAUpdateMultiplePotModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              individualMembershipData={props.individualMembershipData}
              handleManageBackButton={props.handleManageBackButton}
              handleMultipotContinueBtn={props.handleMultipotContinueBtn}
              setPotItem={props.setPotItem}
              potItem={props.potItem}
            />
          </>
        ) : props.popup === "SelectTRA" ? (
          <>
            <TRASelectageModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              handleTraBackBtn={props.handleTraBackBtn}
              handleTraUpdateBtn={props.handleTraUpdateBtn}
              potItem={props.potItem}
              investorId={props.investorId}
              schemeData={props.schemeData}
              error422={props.error422}
              traFetching={props.traFetching}
            />
          </>
        ) : props.popup === "selectIndividualDrawdown" ? (
          <>
            <SelectIndividualDrawdownModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              individualMembershipData={props.individualMembershipData}
              handleContinueButton={props.handleContinueButton}
              memberships={props.memberships}
            />
          </>
        ) : props.popup === "messageModal" ? (
          <>
            <MessageModal
              modalTitle={props.modaltitle}
              handleCloseButton={props.onHide}
              data={props.data}
              onHide={props.onHide}
              setReadModalShow={props.setMessageModalShow}
              handleDelete={props.deleteMessage}
              investorId={props.investorId}
              makeApiToInsertDocStatus={props.makeApiToInsertDocStatus}
            />
          </>
        ) : props.popup === "flexiAccessSummaryOfChanges" ? (
          <>
            <FlexiAccessSummaryOfChangesModal
              data={props.finalFund}
              modaltitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
              fundSwitchError={props.fundSwitchError}
              errorShown={props.errorShown}
            />
          </>
        ) : props.popup === "flexiChangesConfirmed" ? (
          <>
            <FlexiAccessSummaryOfChangesModal
              modaltitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
            />
          </>
        ) : props.popup === "flexiAccessIncomeConfirm" ? (
          <>
            <FlexiAccessConfirmModal
              modaltitle={props.modaltitle}
              handleCloseButton={props.onHide}
              handleContinue={props.handleContinue}
            />
          </>
        ) : props.popup === "signoutModal" ? (
          <>
            <SignoutModal
              handleCloseButton={props.onHide}
              handleConfirm={props.signoutConfirmHandler}
            />
          </>
        ) : props.popup === "combiningTptPots" ? (
          <>
            <CombiningTptPotsModal
              handleCloseButton={props.onHide}
              headTitle={props.headTitle}
              description={props.description}
              subDescription={props.subDescription}
              question={props.question}
              btnCancelName={props.btnCancelName}
              btnSendName={props.btnSendName}
              handleSendLink={props.handleSendLink}
              btnCloseName={props.btnCloseName}
            />
          </>
        ) : props.popup === "morethan95" ? (
          <>
            <MoreThan95Modal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              flaggedStrategyNames={props.flaggedStrategyNames}
              handleContinue={props.handleContinue}
            />
          </>
        ) : props.popup === "TRAWhenFundSwitchRequiredModal" ? (
          <>
            <TRAWhenFundSwitchRequiredModal
              investorId={props.investorId}
              handleCloseButton={props.onHide}
              handleBackButton={props.handleBackButton}
              onCloseClick={props.onCloseClick}
              setIsFundSwitchRequired={props.setIsFundSwitchRequired}
              setUpdateTra={props.setUpdateTra}
              setShowUpdateTra={props.setShowUpdateTra}
              fromSinglePotScreen={props.fromSinglePotScreen}
              age={props.age}
              selectedMultiplePot={props.selectedMultiplePot}
            />
          </>
        ) : props.popup === "moreThan95PercentIncome" ? (
          <>
            <MoreThan95PercentIncomeModal
              handleCloseButton={props.onHide}
              modalTitle={props.modaltitle}
              flexiAccessIncomeNewValue={props.flexiAccessIncomeNewValue}
              periodNewValue={props.periodNewValue}
              handleContinue={props.handleFlexiAccessContinue}
            />
          </>
        ) : (
          <></>
        )}
      </Modal.Body>
    </Modal>
  );
};
